/**
 * @generated SignedSource<<19a6e0d3f3c314b91e5a1e1dfbb4f8ce>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsYourFirmMembers_viewer$data = {
  readonly user: {
    readonly tradeFirm: {
      readonly members: ReadonlyArray<{
        readonly profile: {
          readonly displayName: string | null;
        } | null;
        readonly userId: string | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "TradeBenefitsYourFirmMembers_viewer";
};
export type TradeBenefitsYourFirmMembers_viewer$key = {
  readonly " $data"?: TradeBenefitsYourFirmMembers_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsYourFirmMembers_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsYourFirmMembers_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmMemberType",
              "kind": "LinkedField",
              "name": "members",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Profile",
                  "kind": "LinkedField",
                  "name": "profile",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayName",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "bcadf8721aff000ab554e073dca2dd34";

export default node;
